var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPermissionView)?_c('UnitDmgDepositForm',{attrs:{"damageDeposit":_vm.damageDeposit}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }